// extracted by mini-css-extract-plugin
export default {"rating":"CoursesCard_rating__Yh8op","moreIcon":"CoursesCard_moreIcon__RyT8C"};